<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="saveRecord" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-active="isModalChangeOrdersApproveVisible" :vm-is-valid="!$v.form.$invalid" :vm-title='getTitle')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(v-if="isAdd" vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          input(type="file", ref="file", v-on:change="handleFileUpload()", accept="application/pdf")
</template>
<script>
import { requiredIf } from 'vuelidate/lib/validators' // Ver documentacion
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('InOrders')

export default {
  name: 'ModalChangeOrdersApprove',
  props: {
    form: {
      type: Object
    },
    index: {
      type: Number
    },
    isAdd: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    file: ''
  }),
  validations () {
    return {
      form: {
        file: {
          required: requiredIf(function () { return this.imageValidate })
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'isModalChangeOrdersApproveVisible',
      'inOrder'
    ]),
    getTitle () {
      return 'Approve ' + this.form.name
    },
    imageValidate () {
      return this.file.length < 1
    }
  },
  methods: {
    ...mapActions([
      'setModalChangeOrdersApproveVisible',
      'approveChangeOrder'
    ]),
    async saveRecord () {
      this.approveChangeOrder({ form: this.form, project: this.inOrder, file: this.file })
    },
    close () {
      this.setModalChangeOrdersApproveVisible(false)
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    }
  }
}
</script>
